var ExamsDataTestIdEnum = /* @__PURE__ */ ((ExamsDataTestIdEnum2) => {
  ExamsDataTestIdEnum2["MAIN_EXAMS_LIST"] = "exams--main-exams-list";
  ExamsDataTestIdEnum2["EXAMS_LIST"] = "exams--list";
  ExamsDataTestIdEnum2["CTA_INDEX_CARD_TITLE"] = "cta-index-card--title";
  ExamsDataTestIdEnum2["CTA_INDEX_CARD_DESCRIPTION"] = "cta-index-card--description";
  ExamsDataTestIdEnum2["CTA_INDEX_CARD_BUTTON_PRIMARY"] = "cta-index-card--button-primary";
  ExamsDataTestIdEnum2["CTA_INDEX_CARD_BUTTON_SECONDARY"] = "cta-index-card--button-secondary";
  ExamsDataTestIdEnum2["BRANDING_VALUES_TITLE"] = "branding-values--title";
  ExamsDataTestIdEnum2["BRANDING_VALUES_DESCRIPTION"] = "branding-values--description";
  ExamsDataTestIdEnum2["INDEX_PROCEDURES_IN_CITY_TITLE"] = "index-procedures-in-city--title";
  ExamsDataTestIdEnum2["INDEX_PROCEDURES_IN_CITY_LINK"] = "index-procedures-in-city--link";
  ExamsDataTestIdEnum2["SEE_MORE_INDEX_BUTTON_LINK"] = "see-more-index-button--link";
  ExamsDataTestIdEnum2["INDEX_POST_CONTENT"] = "index-post--content";
  return ExamsDataTestIdEnum2;
})(ExamsDataTestIdEnum || {});
export {
  ExamsDataTestIdEnum
};
